export default {
  title: 'Você já pode fechar esta página. Se tiver alguma dúvida, ligue para',
  'call-rating': 'Avaliação da ligação',
  comment: {
    title: 'Deixe seus comentários:',
    placeholder: 'Conte se gostou de tudo, quais eram suas expectativas e impressões',
    error: 'Você deu uma avaliação baixa — pode explicar o que deu errado?',
    'send-btn': 'Enviar',
  },
  'accepted-message': 'Seu comentário foi recebido. Obrigado por usar nosso serviço de entrega!',
  'rate-thanks': 'Obrigado pelo seu feedback!',
  'rate-prompt': 'Avalie nossa ligação!',
}
